//#region src/services/invitation/IInvitationService.ts
const INVITATION_SERVICE_IDENT = "org.greenhouse.service.InvitationService";

//#endregion
export { INVITATION_SERVICE_IDENT };
//# sourceMappingURL=IInvitationService.js.map